<script setup lang="ts">
// Approved Console v2.dc.html, lines2691–2701; SHA256
// 515398b97fc55027f5b8fa0c20d5c0c67fa7756ee580ad5318ebb8d38d675410.
// Account-only primitives preserve the other shell icons and their consumers.
defineProps<{ name: 'users' | 'key' | 'shield' | 'grid' | 'log' | 'lock' }>()
</script>
<template>
  <span class="console-account-icon">
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.9"
      aria-hidden="true"
    >
      <template v-if="name === 'users'">
        <circle
          cx="9"
          cy="8"
          r="3.2"
        /><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M17 8.2a3 3 0 010 5.6M18 20c0-2.4-1-4-2.5-5" />
      </template>
      <template v-else-if="name === 'key'">
        <circle
          cx="8"
          cy="14"
          r="4"
        /><path d="M11 11l8-8M16 4l3 3M13 7l3 3" />
      </template>
      <template v-else-if="name === 'grid'">
        <rect
          x="4"
          y="4"
          width="6"
          height="6"
          rx="1.2"
        /><rect
          x="14"
          y="4"
          width="6"
          height="6"
          rx="1.2"
        /><rect
          x="4"
          y="14"
          width="6"
          height="6"
          rx="1.2"
        /><rect
          x="14"
          y="14"
          width="6"
          height="6"
          rx="1.2"
        />
      </template>
      <template v-else-if="name === 'lock'">
        <rect
          x="4.5"
          y="10.5"
          width="15"
          height="10"
          rx="2"
        /><path d="M8 10.5V7.5a4 4 0 018 0v3" />
      </template>
      <path
        v-else-if="name === 'shield'"
        d="M12 3l8 4v5c0 4.5-3.2 8.3-8 9.5-4.8-1.2-8-5-8-9.5V7z"
      />
      <path
        v-else
        d="M8 3h11v18H8zM8 3a3 3 0 00-3 3v12a3 3 0 003 3M11 8h5M11 12h5M11 16h3"
      />
    </svg>
  </span>
</template>
<style scoped>
.console-account-icon { width:16px;height:16px;flex:none;opacity:.75;display:flex;align-items:center;justify-content:center; }
.console-account-icon>svg { width:15px;height:15px;opacity:1; }
</style>
